var React = require('react');

function SubMenuArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M60 13.5H98.5V155C98.5 160.244 94.2439 164.5 89 164.5H10C4.75614 164.5 0.5 160.244 0.5 155V13.5H40H40.2462L40.3963 13.3049L50 1.620062L59.6037 13.3049L59.7538 13.5H60Z","fill":"white","stroke":"#9DA4AA"}));
}

SubMenuArrow.defaultProps = {"width":"99","height":"165","viewBox":"0 0 99 165","fill":"none"};

module.exports = SubMenuArrow;

SubMenuArrow.default = SubMenuArrow;
